// ROLES TABLE COLUMNS
export const ROLES_COLUMNS = [
  {
    columnId: "name",
    label: "Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "description",
    label: "Description",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "description",
  },
];

// RESOURCE TABLE COLUMNS
export const RESOURCE_COLUMNS = [
  {
    columnId: "FullName",
    label: "Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "Clients",
    label: "Clients",
    order: 1,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "clients",
  },
  {
    columnId: "email",
    label: "Email",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "email",
  },
  {
    columnId: "roles",
    label: "Roles",
    order: 3,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "roles",
  },
  {
    columnId: "Title",
    label: "Title",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "Title",
  },
  {
    columnId: "HourlyRate",
    label: "Hourly Cost Rate",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "HourlyRate",
  },
  {
    columnId: "HourlyBillRate",
    label: "Hourly Bill Rate",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "HourlyBillRate",
  },
  {
    columnId: "MaxWeeklyHours",
    label: "Max Weekly Hours",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "MaxWeeklyHours",
  },
  {
    columnId: "AvailableWeeklyHours",
    label: "Available Weekly Hours",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "AvailableWeeklyHours",
  },
  {
    columnId: "operationalCapacity",
    label: "Operational Capacity",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "operationalCapacity",
  },
  {
    columnId: "projectCapacity",
    label: "Project Capacity",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "projectCapacity",
  },
  {
    columnId: "type",
    label: "Type",
    order: 11,
    isSortable: false,
    isVisible: true,
    columnType: "select",
    accessorKey: "type",
  },
  {
    columnId: "dateCreated",
    label: "Creation Date",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateCreated",
  },
  {
    columnId: "isActive",
    label: "Status",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isActive",
  },
];

// SHIFT TABLE COLUMNS
export const SHIFT_COLUMNS = [
  {
    columnId: "Name",
    label: "Shift Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "Name",
  },
  {
    columnId: "startTime",
    label: "Hour Range",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "hours",
    accessorKey: "startTime",
  },
];

// ALLOCATED RESOURCE TABLE COLUMNS
export const ALLOCATED_RESOURCES_COLUMNS = [
  {
    columnId: "fullName",
    label: "Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "email",
    label: "Email",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "email",
  },
  {
    columnId: "roles",
    label: "Roles",
    order: 2,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "roles",
  },
  {
    columnId: "title",
    label: "Title",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "Title",
  },
  {
    columnId: "hourlyRate",
    label: "Hourly Cost Rate",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "HourlyRate",
  },
  {
    columnId: "HourlyBillRate",
    label: "Hourly Bill Rate",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "HourlyBillRate",
  },
  {
    columnId: "MaxWeeklyHours",
    label: "Max Weekly Hours",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "MaxHMaxWeeklyHoursours",
  },
  {
    columnId: "AvailableWeeklyHours",
    label: "Available Weekly Hours",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "AvailableWeeklyHours",
  },
  {
    columnId: "operationalCapacity",
    label: "Operational Capacity",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "operationalCapacity",
  },
  {
    columnId: "projectCapacity",
    label: "Project Capacity",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "projectCapacity",
  },
  {
    columnId: "type",
    label: "Type",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "type",
  },
  {
    columnId: "isActive",
    label: "Status",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isActive",
  },
  {
    columnId: "dateCreated",
    label: "Creation Date",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateCreated",
  },
];

// CLIENT TABLE COLUMNS
export const CLIENTS_COLUMNS = [
  {
    columnId: "name",
    label: "Client",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Reference ID",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "manager",
    label: "Client Manager",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "manager",
  },
  {
    columnId: "industry",
    label: "Industry",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "industry",
  },
  {
    columnId: "status",
    label: "Status",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "status",
  },
  {
    columnId: "C_St",
    label: "Contract Start Date",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "contractStartDate",
  },
  {
    columnId: "C_En",
    label: "Contract End Date",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "contractEndDate",
  },
  {
    columnId: "dateCreated",
    label: "Creation Date",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateCreated",
  },
];

// PORTFOLIO TABLE COLUMNS
export const PORTFOLIO_COLUMNS = [
  {
    columnId: "name",
    label: "Portfolio",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Reference ID",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "owner",
    label: "Portfolio Manager",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "owner",
  },
  {
    columnId: "budget",
    label: "Budget",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "budget",
  },
  {
    columnId: "status",
    label: "Status",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "status",
  },
  {
    columnId: "riskLevel",
    label: "Risk Level",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "riskLevel",
  },
  {
    columnId: "startDate",
    label: "Start Date",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "startDate",
  },
  {
    columnId: "endDate",
    label: "End Date",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "endDate",
  },
  {
    columnId: "dateCreated",
    label: "Creation Date",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateCreated",
  },
];

// PROGRAM TABLE COLUMNS
export const PROGRAMS_COLUMNS = [
  {
    columnId: "name",
    label: "Program",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Reference ID",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "po_name",
    label: "Portfolio",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "portfolio",
  },
  {
    columnId: "owner",
    label: "Program Manager",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "owner",
  },
  {
    columnId: "status",
    label: "Status",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "status",
  },
  {
    columnId: "budget",
    label: "Budget",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "budget",
  },
  {
    columnId: "actual",
    label: "Actual",
    order: 7,
    isSortable: true,
    isVisible: true,
    // isEditable: false,
    columnType: "number",
    accessorKey: "actual",
  },
  {
    columnId: "accural",
    label: "Accural",
    order: 8,
    isSortable: true,
    isVisible: true,
    // isEditable: false,
    columnType: "number",
    accessorKey: "accural",
  },
  {
    columnId: "etc",
    label: "ETC",
    order: 9,
    isSortable: true,
    isVisible: true,
    // isEditable: false,
    columnType: "number",
    accessorKey: "etc",
  },
  {
    columnId: "bac",
    label: "BAC",
    order: 10,
    isSortable: true,
    isVisible: true,
    // isEditable: false,
    columnType: "number",
    accessorKey: "bac",
  },
];

// PROJECT TABLE COLUMNS
export const PROJECT_COLUMNS = [
  {
    columnId: "name",
    label: "Project",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Reference ID",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "type",
    label: "Type",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "type",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "po_name",
    label: "Portfolio",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "portfolio",
  },
  {
    columnId: "pr_name",
    label: "Program",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "program",
  },
  {
    columnId: "owner",
    label: "Project Manager",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "owner",
  },
  {
    columnId: "status",
    label: "Status",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "budget",
    label: "Budget",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "budget",
  },
  {
    columnId: "actual",
    label: "Actual",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "actual",
  },
  {
    columnId: "accural",
    label: "Accural",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "accural",
  },
  // {
  //   columnId: "etc",
  //   label: "ETC",
  //   order: 9,
  //   isSortable: true,
  //   isVisible: true,
  //   columnType: "number",
  //   accessorKey: "accural",
  // },
  // {
  //   columnId: "bac",
  //   label: "BAC",
  //   order: 10,
  //   isSortable: true,
  //   isVisible: true,
  //   columnType: "number",
  //   accessorKey: "accural",
  // },
  {
    columnId: "startDate",
    label: "Start Date",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "startDate",
  },
  {
    columnId: "endDate",
    label: "End Date",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "endDate",
  },
];

// SCOPE TABLE COLUMNS
export const SCOPE_COLUMNS = [
  {
    columnId: "name",
    label: "Scope",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Reference ID",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "isMilestone",
    label: "Milestone",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isMilestone",
  },
  {
    columnId: "phase",
    label: "Phase",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "phase",
  },
  {
    columnId: "status",
    label: "Status",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "priority",
    label: "Priority",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "priority",
  },
  {
    columnId: "budget",
    label: "Budget",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "budget",
  },
  {
    columnId: "tasksCount",
    label: "Tasks",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "tasksCount",
  },
  {
    columnId: "actual",
    label: "Actual",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "actual",
  },
  {
    columnId: "accural",
    label: "Accural",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "accural",
  },
  {
    columnId: "etc",
    label: "ETC",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "etc",
  },
  {
    columnId: "bac",
    label: "BAC",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "bac",
  },
  {
    columnId: "startDate",
    label: "Start Date",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "startDate",
  },
  {
    columnId: "endDate",
    label: "End Date",
    order: 14,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "endDate",
  },
  {
    columnId: "progress",
    label: "%",
    order: 15,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "progress",
  },
];

// SCOPE TABLE COLUMNS
export const MILESTONE_COLUMNS = [
  {
    columnId: "title",
    label: "Milestone",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "title",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "s_name",
    label: "Scope",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "scope",
  },
  {
    columnId: "t_name",
    label: "Task",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "task",
  },
  {
    columnId: "budget",
    label: "Budget",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "budget",
  },
  {
    columnId: "status",
    label: "Status",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "priority",
    label: "Priority",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "priority",
  },
  {
    columnId: "targetDate",
    label: "Target Date",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "targetDate",
  },
  {
    columnId: "description",
    label: "Description",
    order: 8,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "description",
  },
];

// TASK TABLE COLUMNS
export const TASK_COLUMNS = [
  {
    columnId: "name",
    label: "Task",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Change Ticket",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "progress",
    label: "%",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "progress",
  },
  {
    columnId: "description",
    label: "Description",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "description",
  },
  {
    columnId: "phase",
    label: "Phase",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "phase",
  },
  {
    columnId: "status",
    label: "Status",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "priority",
    label: "Priority",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "priority",
  },
  {
    columnId: "isCritical",
    label: "Critical",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isCritical",
  },
  {
    columnId: "isMilestone",
    label: "Milestone",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isMilestone",
  },
  {
    columnId: "isInWsr",
    label: "In WSR",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isInWsr",
  },
  {
    columnId: "startDate",
    label: "Start Date",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "startDate",
  },
  {
    columnId: "endDate",
    label: "End Date",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "endDate",
  },
  {
    columnId: "totalHours",
    label: "Total Hours",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalHours",
  },
  {
    columnId: "resources",
    label: "Resources",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "resources",
  },
];

// CHANGE REQUEST TABLE COLUMNS
export const CHANGE_REQUEST_COLUMNS = [
  {
    columnId: "name",
    label: "Title",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "type",
    label: "Type",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "type",
  },
  {
    columnId: "status",
    label: "Status",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "priority",
    label: "Priority",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "priority",
  },
  {
    columnId: "sponsor",
    label: "Sponsor",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "sponsor",
  },
  {
    columnId: "totalBudget",
    label: "Total Value",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalBudget",
  },
  {
    columnId: "totalETC",
    label: "Total ETC",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalETC",
  },
  {
    columnId: "eta",
    label: "ETA",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "eta",
  },
  {
    columnId: "additional",
    label: "Additional Materials",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "additional",
  },
];

// RISK TABLE COLUMNS
export const RISK_COLUMNS = [
  {
    columnId: "name",
    label: "Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "scope",
    label: "Affected Scope",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "scope",
  },
  {
    columnId: "task",
    label: "Affected Task",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "task",
  },
  {
    columnId: "description",
    label: "Description",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "description",
  },
  {
    columnId: "cr_name",
    label: "Change Request",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "changeRequest",
  },
  // {
  //   columnId: "users",
  //   label: "Users",
  //   order: 5,
  //   isSortable: false,
  //   isVisible: true,
  //   columnType: "select",
  //   accessorKey: "users",
  // },
  {
    columnId: "type",
    label: "Type",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "type",
  },
  {
    columnId: "isIssue",
    label: "Is Issue",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isIssue",
  },
  {
    columnId: "owner",
    label: "Prime",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "owner",
  },
  {
    columnId: "probability",
    label: "Probability",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "probability",
  },
  {
    columnId: "impact",
    label: "Impact",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "impact",
  },
  {
    columnId: "severity",
    label: "Severity",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "severity",
  },
  {
    columnId: "status",
    label: "Status",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "dateIdentified",
    label: "Date Identified",
    order: 14,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateIdentified",
  },
  {
    columnId: "dateImpact",
    label: "Date of Impact",
    order: 15,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateImpact",
  },
  {
    columnId: "dateResolved",
    label: "Date Resolved",
    order: 16,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateResolved",
  },
  {
    columnId: "mitigationPlan",
    label: "Mitigation Plan",
    order: 17,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "mitigationPlan",
  },
  {
    columnId: "isInWsr",
    label: "In WSR",
    order: 18,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isInWsr",
  },
  {
    columnId: "trending",
    label: "Trending",
    order: 19,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "trending",
  },
];

// COMMUNICATION TABLE COLUMNS
export const COMMUNICATION_PLANS_COLUMNS = [
  {
    columnId: "title",
    label: "Title",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "title",
  },
  {
    columnId: "c_name",
    label: "Client",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "po_name",
    label: "Portfolio",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "portfolio",
  },
  {
    columnId: "pr_name",
    label: "Program",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "program",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "message",
    label: "Message",
    order: 5,
    isSortable: true,
    isVisible: false,
    columnType: "text",
    accessorKey: "message",
  },
  {
    columnId: "audience",
    label: "Audience",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "audience",
  },
  {
    columnId: "time",
    label: "Frequency/When",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "time",
  },
  {
    columnId: "medium",
    label: "Medium",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "medium",
  },
  {
    columnId: "source",
    label: "Source",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "source",
  },
  {
    columnId: "expeditor",
    label: "Expeditor",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "expeditor",
  },
  {
    columnId: "status",
    label: "Status",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "status",
  },
  {
    columnId: "category",
    label: "Category",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "category",
  },
  {
    columnId: "highlights",
    label: "Purpose/Highlights",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "highlights",
  },
  {
    columnId: "results",
    label: "Expected Results/ Key Message",
    order: 14,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "results",
  },
];

export const BUDGET_CATEGORY_COLUMNS = [
  {
    columnId: "p_name",
    label: "Project",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "category",
    label: "Category",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "category",
  },
  {
    columnId: "totalInitialBudgetCost",
    label: "Total Initial Budget",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalInitialBudgetCost",
  },
  {
    columnId: "totalChangeRequestsCost",
    label: "Total Change Request",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalChangeRequestsCost",
  },
  {
    columnId: "totalRevisedBudgetCost",
    label: "Total Revised Budget",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalRevisedBudgetCost",
  },
  // Program, Project
  { columnId: "totalForecastAllocation", label: "Total Forecast Allocation", order: 5, isSortable: true, isVisible: true, accessorKey: "totalForecastAllocation" },
  { columnId: "totalForecastHours", label: "Total Forecast Hours", order: 6, isSortable: true, isVisible: true, accessorKey: "totalForecastHours" },
  { columnId: "totalActualHours", label: "Total Actual Hours", order: 7, isSortable: true, isVisible: true, accessorKey: "totalActualHours" },
  { columnId: "totalForecastHourlyCostRate", label: "Total Forecast hourly Cost", order: 8, isSortable: true, isVisible: true, accessorKey: "totalForecastHourlyCostRate" },
  { columnId: "totalForecastHourlyBillRate", label: "Total Forecast hourly Bill", order: 9, isSortable: true, isVisible: true, accessorKey: "totalForecastHourlyBillRate" },
  { columnId: "totalForecastTotalCost", label: "Total Forecast Cost", order: 10, isSortable: true, isVisible: true, accessorKey: "totalForecastTotalCost" },
  { columnId: "totalForecastTotalBill", label: "Total Forecast Bill", order: 11, isSortable: true, isVisible: true, accessorKey: "totalForecastTotalBill" },
  {
    columnId: "totalInvoiced",
    label: "Total Invoiced",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalInvoiced",
  },
  {
    columnId: "totalAccural",
    label: "Total Accural",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalAccural",
  },
  {
    columnId: "totalSpent",
    label: "Total Spent",
    order: 14,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalSpent",
  },
  {
    columnId: "totalActual",
    label: "Total Actual",
    order: 15,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalActual",
  },
  {
    columnId: "totalPV",
    label: "Total PV",
    order: 16,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalPV",
  },
  {
    columnId: "totalEV",
    label: "Total EV",
    order: 17,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalEV",
  },
  {
    columnId: "totalETC",
    label: "Total ETC",
    order: 18,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalETC",
  },
  { columnId: "totalForecastCv", label: "Total Forecast CV", order: 19, isSortable: true, isVisible: true, accessorKey: "totalForecastCv" },
  { columnId: "totalForecastHv", label: "Total Forecast HV", order: 20, isSortable: true, isVisible: true, accessorKey: "totalForecastHv" },
  {
    columnId: "totalBAC",
    label: "Total BAC",
    order: 21,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalBAC",
  },
  {
    columnId: "totalCV",
    label: "Total CV",
    order: 22,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "totalCV",
  },
  // {
  //   columnId: "totalSV",
  //   label: "Total SV",
  //   order: 23,
  //   isSortable: true,
  //   isVisible: true,
  //   columnType: "number",
  //   accessorKey: "totalSV",
  // },
];

// BUDGET TABLE COLUMNS
export const BUDGET_COLUMNS = [
  // {
  //   columnId: "name",
  //   label: "Description",
  //   order: 0,
  //   isSortable: true,
  //   isVisible: true,
  //   columnType: "text",
  //   accessorKey: "name",
  // },
  {
    columnId: "c_name",
    label: "Client",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "client",
  },
  {
    columnId: "p_name",
    label: "Project",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "category",
    label: "Category",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "category",
  },
  {
    columnId: "code",
    label: "Payment Code",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "code",
  },
  {
    columnId: "initialBudgetCost",
    label: "Initial Budget",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "initialBudgetCost",
  },
  {
    columnId: "changeRequestsCost",
    label: "Change Request",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "changeRequestsCost",
  },
  {
    columnId: "revisedBudgetCost",
    label: "Revised Budget",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "revisedBudgetCost",
  },//Budgets, portfolio,
  { columnId: "forecastAllocation", label: "Forecast Allocation", order: 5, isSortable: true, isVisible: true, accessorKey: "forecastAllocation" },
  { columnId: "forecastHours", label: "Forecast Hours", order: 6, isSortable: true, isVisible: true, accessorKey: "forecastHours" },
  { columnId: "actualHours", label: "Actual Hours", order: 7, isSortable: true, isVisible: true, accessorKey: "actualHours" },
  { columnId: "forecastHourlyCostRate", label: "Forecast hourly Cost", order: 8, isSortable: true, isVisible: true, accessorKey: "forecastHourlyCostRate" },
  { columnId: "forecastHourlyBillRate", label: "Forecast hourly Bill", order: 9, isSortable: true, isVisible: true, accessorKey: "forecastHourlyBillRate" },
  { columnId: "forecastTotalCost", label: "Forecast Cost", order: 10, isSortable: true, isVisible: true, accessorKey: "forecastCost" },
  { columnId: "forecastTotalBill", label: "Forecast Bill", order: 11, isSortable: true, isVisible: true, accessorKey: "forecastBill" },
  {
    columnId: "invoiced",
    label: "Invoiced",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "invoiced",
  },
  {
    columnId: "accural",
    label: "Accural",
    order: 13,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "accural",
  },
  {
    columnId: "spent",
    label: "Spent",
    order: 14,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "spent",
  },
  {
    columnId: "actual",
    label: "Actual",
    order: 15,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "actual",
  },
  {
    columnId: "pv",
    label: "PV",
    order: 16,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "pv",
  },
  {
    columnId: "ev",
    label: "EV",
    order: 17,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "ev",
  },
  {
    columnId: "etc",
    label: "ETC",
    order: 18,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "etc",
  },
  { columnId: "forecastCv", label: "Forecast CV", order: 19, isSortable: true, isVisible: true, accessorKey: "forecastCv" },
  { columnId: "forecastHv", label: "Forecast HV", order: 20, isSortable: true, isVisible: true, accessorKey: "forecastHv" },
  {
    columnId: "bac",
    label: "BAC",
    order: 21,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "bac",
  },
  {
    columnId: "cv",
    label: "CV",
    order: 22,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "cv",
  },
  // {
  //   columnId: "sv",
  //   label: "SV",
  //   order: 23,
  //   isSortable: true,
  //   isVisible: true,
  //   columnType: "number",
  //   accessorKey: "sv",
  // },
];

// MEETING REGISTRY TABLE COLUMNS
export const MEETING_REGISTRY = [
  {
    columnId: "name",
    label: "Meeting Minutes",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "time",
    label: "Date",
    isSortable: true,
    order: 1,
    isVisible: true,
    columnType: "text",
    accessorKey: "time",
  },
  {
    columnId: "owner",
    label: "Meeting Owner",
    isSortable: true,
    order: 2,
    isVisible: true,
    columnType: "text",
    accessorKey: "owner",
  },
];

export const Get_HEALTH_STATUS_COLUMNS = (type) => {
  if (type === "program") {
    return [
      ...HEALTH_STATUS_COLUMNS,
      {
        columnId: "programName",
        label: "Program",
        userLabel: "project",
        order: 1,
        isSortable: true,
        isVisible: true,
        columnType: "text",
        accessorKey: "programName",
      },
    ];
  } else {
    return [
      ...HEALTH_STATUS_COLUMNS,
      {
        columnId: "projectName",
        label: "Project",
        userLabel: "Project",
        order: 1,
        isSortable: true,
        isVisible: true,
        columnType: "text",
        accessorKey: "projectName",
      },
    ];
  }
};
// HEALTH STATUS TABLE COLUMNS
export const HEALTH_STATUS_COLUMNS = [
  {
    columnId: "globalStatus",
    label: "Status",
    userLabel: "Status",
    order: 0,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "globalStatus",
  },
  {
    columnId: "scope",
    label: "Scope",
    userLabel: "Scope",
    order: 2,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "scope",
  },
  {
    columnId: "time",
    label: "Time",
    userLabel: "Time",
    order: 3,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "time",
  },
  {
    columnId: "cost",
    label: "Cost",
    userLabel: "Cost",
    order: 4,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "cost",
  },
  {
    columnId: "quality",
    label: "Quality",
    userLabel: "Quality",
    order: 5,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "quality",
  },
  {
    columnId: "issues",
    label: "Issues",
    userLabel: "Issues",
    order: 6,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "issues",
  },
  {
    columnId: "risks",
    label: "Risks",
    userLabel: "Risks",
    order: 7,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "risks",
  },
  {
    columnId: "resources",
    label: "Resources",
    userLabel: "Resources",
    order: 8,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "resources",
  },
];

// PURCHASE_ORDERS TABLE COLUMNS
export const PURCHASE_ORDERS_COLUMNS = [
  {
    columnId: "vendor",
    label: "Vendor",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "vendor",
  },
  {
    columnId: "pr",
    label: "PR",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "pr",
  },
  {
    columnId: "poId",
    label: "PO #",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "poId",
  },
  {
    columnId: "description",
    label: "Description",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "description",
  },
  {
    columnId: "createdAt",
    label: "Created Date",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "createdAt",
  },
  {
    columnId: "endAt",
    label: "End Date",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "endAt",
  },
  {
    columnId: "value",
    label: "Value",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "value",
  },
  {
    columnId: "paid",
    label: "Paid",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "paid",
  },
  {
    columnId: "accural",
    label: "Accural",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "accural",
  },
  {
    columnId: "outstandingValue",
    label: "Outstanding Value",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "outstandingValue",
  },
  {
    columnId: "status",
    label: "Status",
    order: 11,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "comments",
    label: "Comments",
    order: 12,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "comments",
  },
];

// DECISION_LOG TABLE COLUMNS
export const DECISION_LOG_COLUMNS = [
  {
    columnId: "title",
    label: "Decision",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "title",
  },
  {
    columnId: "project",
    label: "Project",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "project",
  },
  {
    columnId: "owner",
    label: "Owner",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "owner",
  },
  {
    columnId: "datePresented",
    label: "Date Presented",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "datePresented",
  },
  {
    columnId: "dateDecided",
    label: "Date Decided",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "dateDecided",
  },
  {
    columnId: "comments",
    label: "Comments",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "comments",
  },
];

// RUNBOOK TABLE COLUMNS
export const RUNBOOK_COLUMNS = [
  {
    columnId: "name",
    label: "Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "name",
  },
  {
    columnId: "refId",
    label: "Change Ticket",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "refId",
  },
  {
    columnId: "status",
    label: "Status",
    order: 2,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "status",
  },
  {
    columnId: "owner",
    label: "Owner",
    order: 3,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "owner",
  },
  {
    columnId: "plannedStartDate",
    label: "Planned Dates",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "plannedStartDate",
  },
  {
    columnId: "plannedDurationMinutes",
    label: "Planned Duration",
    order: 5,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "plannedDurationMinutes",
  },
  {
    columnId: "actualStartDate",
    label: "Actual Dates",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "actualStartDate",
  },
  {
    columnId: "actualDurationMinutes",
    label: "Actual Duration",
    order: 7,
    isSortable: false,
    isVisible: true,
    columnType: "text",
    accessorKey: "actualDurationMinutes",
  },
];

// INVOICE_REGISTRY TABLE COLUMNS
export const INVOICE_REGISTRY_COLUMNS = [
  {
    columnId: "purchaseOrder",
    label: "PO",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "purchaseOrder",
  },
  {
    columnId: "vendor",
    label: "Supplier Name",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "vendor",
  },
  {
    columnId: "supplierInvId",
    label: "Supplier Inv #",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "supplierInvId",
  },
  {
    columnId: "date",
    label: "Invoice Date",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "date",
  },
  {
    columnId: "internalInvId",
    label: "Internal Inv #",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "internalInvId",
  },
  {
    columnId: "lineDescription",
    label: "Payment Code",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "lineDescription",
  },
  {
    columnId: "valueBeforeTax",
    label: "Value Before Tax",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "valueBeforeTax",
  },
  {
    columnId: "paidDate",
    label: "Paid Date",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "paidDate",
  },
  {
    columnId: "account",
    label: "Account",
    order: 8,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "account",
  },
  {
    columnId: "comments",
    label: "Comments",
    order: 9,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "comments",
  },
  {
    columnId: "isInLedger",
    label: "In Ledger",
    order: 10,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "isInLedger",
  },
];

// Reshuffle Requests
export const RESHUFFLE_REQUEST_COLUMNS = [
  {
    columnId: "targetResource",
    label: "Resource",
    order: 0,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "targetResource",
  },
  {
    columnId: "requestedHours",
    label: "Requested Hours",
    order: 1,
    isSortable: true,
    isVisible: true,
    columnType: "number",
    accessorKey: "requestedHours",
  },
  {
    columnId: "period",
    label: "Period",
    order: 2,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "periodStartYear",
  },
  {
    columnId: "status",
    label: "Status",
    order: 3,
    isSortable: true,
    isVisible: true,
    columnType: "select",
    accessorKey: "status",
  },
  {
    columnId: "creator",
    label: "Creator",
    order: 4,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "creator",
  },
  {
    columnId: "reviewer",
    label: "Reviewer",
    order: 5,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "reviewer",
  },
  {
    columnId: "reviewedAt",
    label: "Reviewed At",
    order: 6,
    isSortable: true,
    isVisible: true,
    columnType: "date",
    accessorKey: "reviewedAt",
  },
  {
    columnId: "changeRequest",
    label: "Change Request",
    order: 7,
    isSortable: true,
    isVisible: true,
    columnType: "text",
    accessorKey: "changeRequest",
  },
];

//CASHFLOW
export const CASHFLOW_COLUMNS = [
  { columnId: "Description", label: "Description", order: 0, isSortable: false, isVisible: true, accessorKey: "description" },
  { columnId: "For. Allocation", label: "For. Allocation", order: 1, isSortable: false, isVisible: false, accessorKey: "forecastAllocation" },
  { columnId: "For. Hours", label: "For. Hours", order: 2, isSortable: false, isVisible: false, accessorKey: "forecastHours" },
  { columnId: "Act. Hours", label: "Act. Hours", order: 3, isSortable: false, isVisible: false, accessorKey: "actualHours" },
  { columnId: "For. HV", label: "For. HV", order: 4, isSortable: false, isVisible: false, accessorKey: "ForecastHv" },
  { columnId: "For. h. Cost", label: "For. h. Cost", order: 5, isSortable: false, isVisible: false, accessorKey: "forecastHourlyCostRate" },
  { columnId: "For. h. Bill", label: "For. h. Bill", order: 6, isSortable: false, isVisible: false, accessorKey: "forecastHourlyBillRate" },
  { columnId: "For. Total Cost", label: "For. Total Cost", order: 7, isSortable: false, isVisible: false, accessorKey: "forecastTotalCost" },
  { columnId: "For. Total Bill", label: "For. Total Bill", order: 8, isSortable: false, isVisible: false, accessorKey: "forecastTotalBill" },
  { columnId: "INV", label: "INV", order: 9, isSortable: true, isVisible: true, accessorKey: "inv" },
  { columnId: "AC", label: "AC", order: 10, isSortable: true, isVisible: true, accessorKey: "ac" },
  { columnId: "For. CV", label: "For. CV", order: 11, isSortable: false, isVisible: false, accessorKey: "cv" },
  { columnId: "For. GP", label: "For. GP", order: 12, isSortable: false, isVisible: false, accessorKey: "forecastGp" },
  { columnId: "GP", label: "GP", order: 13, isSortable: true, isVisible: true, accessorKey: "gp" },
  { columnId: "Totals", label: "Totals", order: 14, isSortable: false, isVisible: true, accessorKey: "totals" },
];

export const PROGRAM_BUDGET_COLUMNS = [
  {
    accessorKey: "projectName",
    header: "Project",
    label: "Project",
    size: 200,
    isVisible: true,
    isSortable: true,
    columnType: "text",
    columnId: "projectName",
    order: 1,
  },
  ...BUDGET_CATEGORY_COLUMNS.filter((col) => col.label !== "Category").map((col, index) => ({
    ...col,
    order: index + 2,
  }))
];
